import React, { type PropsWithChildren } from "react";
import Image from "next/image";
import { Box, Flex, type SpaceProps } from "@chakra-ui/react";

/**
 * A green-toned card with a static, bottom-centered aura background.
 */
export function AuraCard({ children, ...spaceProps }: PropsWithChildren<SpaceProps>) {
  return (
    <Box
      pos="relative"
      borderRadius={{ base: "big", sm: "bigger" }}
      px={{ base: "big", md: "biggest", xl: "huge" }}
      py={{ base: "biggest", sm: "huge", xl: "huger" }}
      bg="brand.backgroundSecondary.light"
      color="new.green.900"
      overflow="hidden"
      {...spaceProps}
    >
      <AuraCardBg />
      <Box pos="relative">{children}</Box>
    </Box>
  );
}

function AuraCardBg() {
  return (
    <Flex aria-hidden="true" pos="absolute" boxSize="100%" inset={0}>
      <Box display={{ base: "none", md: "inline-block" }} pos="relative" boxSize="100%">
        <Image
          fill
          sizes="100%"
          src="/assets/cards/aura-bg.png"
          alt="Background gradient."
          style={{ objectFit: "cover", objectPosition: "center top" }}
        />
      </Box>
      <Box display={{ base: "inline-block", md: "none" }} pos="relative" boxSize="100%">
        <Image
          fill
          sizes="100%"
          src="/assets/cards/aura-bg-mobile.png"
          alt="Background gradient."
          style={{ objectFit: "cover", objectPosition: "center bottom" }}
        />
      </Box>
    </Flex>
  );
}
